import { atom } from 'recoil'
import { Doctor } from '../types'
import { localStorageEffect } from '../utils/recoil'

interface DoctorAtom {
  profile_image_url: Doctor['profile_image_url']
  hospital_name: Doctor['hospital_name']
  name: Doctor['name']
  id: Doctor['id']
}

const doctorAtom = atom<DoctorAtom | null>({
  key: 'doctorState',
  default: null,
  effects_UNSTABLE: [localStorageEffect('doctorState')],
})

export const accessTokenState = atom<string | null>({
  key: 'accessTokenState',
  default: null,
  effects_UNSTABLE: [localStorageEffect('accessTokenState')],
})

export const accessTokenForViewerState = atom<string | null>({
  key: 'accessTokenForViewerState',
  default: null,
  effects_UNSTABLE: [localStorageEffect('accessTokenForViewerState')],
})

export const accessTokenForChartState = atom<string | null>({
  key: 'accessTokenForChartState',
  default: null,
  effects_UNSTABLE: [localStorageEffect('accessTokenForChartState')],
})

export default doctorAtom
